<template>

    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange">
        <Cactivity :navsub="navsub" :options="c_myoption" v-if="isload"></Cactivity>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'assignment',
        mixins: [mixinmember],
        components: {
            Cactivity: () => import('@/components/Cactivity')
        },
        data() {
            return {
                curnavkv: 2
            };
        },
        computed: {
            c_options: function () {
                let _options = { 'hasoption': true, 'courselev': 2, 'showcourse': 2, 'haskw': false, 'noteng': 1, 'issch': 1, 'anycourse': false };
                switch (this.navsub) {
                    case 0:
                        _options.schstat = 1;
                        break;
                    case 1:
                        _options.schstat = 2;
                        break;
                }
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                switch (this.navsub) {
                    case 0:
                        _myoption.schstat = 1;
                        break;
                    case 1:
                        _myoption.schstat = 2;
                        break;
                }
                return _myoption;
            }
        }
    }
</script>
